import type { Editor } from "@tiptap/react";

export const scrollToBottom = (scrollerId = "message-scroll-view") => {
  const element = document.getElementById(scrollerId);
  if (!element) return;
  element.scrollTop = element.scrollHeight;
};

export const isImeComposing = (event: KeyboardEvent) =>
  event.isComposing || event.keyCode === 229;

export const doesEditorContainsEditedLabel = (editor: Editor) => {
  let hasEditedLabel = false;
  try {
    editor.state.doc.descendants((node: any) => {
      if (node.type.name == "editedlabel") {
        hasEditedLabel = true;
      }
    });
  } catch (error) {
    console.error(error);
  }
  return hasEditedLabel;
};
